<script>
</script>

<section class="content-header">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <h1>Oops!</h1>
            </div>
        </div>
    </div>
</section>
<section class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        La página a la que intenta acceder no existe.
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
